<template>
  <div class="-csm-box wt2-text-n">
    <span v-if="csmSentenceText" v-html="csmSentenceText" />
    <a
      v-if="csmLinkText"
      class="wt2-color-primary"
      @click="contactSupport"
      v-text="csmLinkText"
    />
    <span v-if="csmSentenceTextEnd" v-html="csmSentenceTextEnd" />
  </div>
</template>

<script>
import app from 'app';

export default {
  props: {
    csmSentenceText: {
      type: String,
      required: false,
      default: 'You could try again or',
    },
    csmLinkText: {
      type: String,
      required: false,
      default: 'contact our support.',
    },
    csmSentenceTextEnd: {
      type: String,
      required: false,
      default: '',
    },
    csmChatMessage: {
      type: String,
      default:
        'Hi, \n' + 'Something went wrong, can you please check?\n' + 'Thanks\n',
    },
  },

  methods: {
    contactSupport() {
      app.intercomController.showNewMessage(this.csmChatMessage).catch(() => {
        // fallback - if there no intercom, go to website support
        app.openSupportTab();
      });
    },
  },
};
</script>
